import React from "react";
import { Loader2 } from "lucide-react";
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../ui/alert-dialog";
import { Button } from "../ui/button";
import { ADMIN_PANEL, BTN_OUTLINE } from "../../config/brand";

export default function ConfirmDialog({
  open,
  onOpenChange,
  title,
  description,
  confirmLabel = "Confirmer",
  confirmingLabel = "Suppression...",
  onConfirm,
  confirming = false,
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className={`${ADMIN_PANEL} text-slate-900`}>
        <AlertDialogHeader>
          <AlertDialogTitle className="tracking-tight text-slate-900">{title}</AlertDialogTitle>
          <AlertDialogDescription className="text-slate-500">{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className={BTN_OUTLINE} disabled={confirming}>
            Annuler
          </AlertDialogCancel>
          <Button
            onClick={onConfirm}
            disabled={confirming}
            className="rounded-full bg-red-600 hover:bg-red-700 text-white shadow-none"
          >
            {confirming ? (
              <>
                <Loader2 className="h-4 w-4 animate-spin mr-2" />
                {confirmingLabel}
              </>
            ) : (
              confirmLabel
            )}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
